"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAddressValue = exports.getAddressParts = exports.formatSuggestions = exports.formatSelected = void 0;

var getAddressValue = function getAddressValueMethod(input, prefix) {
  if (!input) {
    return '';
  }

  return "".concat(prefix).concat(input);
};

exports.getAddressValue = getAddressValue;

var getAddressParts = function getAddressPartsMethod(suggestion) {
  var formatEntries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    street: getAddressValue(suggestion.streetLine, ''),
    secondary: getAddressValue(suggestion.secondary, ' '),
    entries: suggestion.entries > 1 ? "".concat(formatEntries ? ' (' : '').concat(suggestion.entries, " more entries").concat(formatEntries ? ')' : '') : '',
    city: getAddressValue(suggestion.city, ', '),
    state: getAddressValue(suggestion.state, ', '),
    zip: getAddressValue(suggestion.zipcode, ' ')
  };
};

exports.getAddressParts = getAddressParts;

var formatSuggestion = function formatSuggestionMethod(suggestion) {
  var _getAddressParts = getAddressParts(suggestion, true),
      street = _getAddressParts.street,
      secondary = _getAddressParts.secondary,
      entries = _getAddressParts.entries,
      city = _getAddressParts.city,
      state = _getAddressParts.state,
      zip = _getAddressParts.zip;

  var label = street + secondary + entries + city + state + zip;
  return {
    suggestion: suggestion,
    label: label
  };
};

var formatSuggestions = function formatSuggestions(suggestions) {
  return suggestions.map(formatSuggestion);
};

exports.formatSuggestions = formatSuggestions;

var formatSelected = function formatSelectedMethod(_ref) {
  var streetLine = _ref.streetLine,
      secondary = _ref.secondary,
      entries = _ref.entries,
      city = _ref.city,
      state = _ref.state,
      zipcode = _ref.zipcode;
  return "".concat(streetLine, " ").concat(secondary, " (").concat(entries, ") ").concat(city, " ").concat(state, " ").concat(zipcode);
};

exports.formatSelected = formatSelected;